import DraftFormat from './DraftFormat.js';
import JoustFormat from './JoustFormat.js';
import MeleeFormat from './MeleeFormat.js';

export default [MeleeFormat, JoustFormat, DraftFormat];
